import { Text } from "@/atoms"

// A label and its value, in the details grid's two columns
export const DetailField = (props: {
  label: string
  children: React.ReactNode
}) => (
  <>
    <Text type="secondary">{props.label}</Text>
    <Text>{props.children}</Text>
  </>
)
